import type { IconData } from '@stacksjs/iconify-core'

export const chartPie: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M105.361 398.32A195.891 195.891 0 0 1 343.42 91.125l23.256-23.255A227.875 227.875 0 0 0 82.733 420.948A228.03 228.03 0 0 0 366.24 452.1l-23.312-23.312c-75.028 43.98-173.271 33.829-237.567-30.468\"/><path fill=\"currentColor\" d=\"M468.916 353.07a243.54 243.54 0 0 0 0-186.459a248 248 0 0 0-2.747-6.354a242.3 242.3 0 0 0-50.059-72.686L404.8 76.257l-11.317 11.314l-172.27 172.269l172.63 172.631l10.957 10.953l11.31-11.314a242.2 242.2 0 0 0 49.452-71.358a249 249 0 0 0 3.354-7.682m-64.557-231.12a211.57 211.57 0 0 1 0 275.781L266.468 259.84Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default chartPie
